/**
 * {paymentNotice}の小さな部品（#233 3b、docs/93 §15.6）：状態のチップ（色だけで伝えない＝文字で）と、仕入の一覧の切り替え（仕入｜{paymentNotice}）
 *   下書き（番号ありも。#278）／未送付／確認待ち n日／確認済 MM/DD／確認済（期限経過）／誤りあり（朱）
 */
import { PAYMENT_NOTICE_MSG, PURCHASE_MSG, noticeStateText, unissuedTitle, type NoticeState } from "@genbaryoku/contract";
import { useNavigate } from "react-router";
import { Segmented } from "../../components/Segmented.jsx";
import { t } from "../../labels.js";
import { mdSlash } from "../../lib/num.js";

const cls = (s: NoticeState) => (s === "disputed" ? "chip shu" : s === "confirmed" || s === "expired" ? "chip ai" : "chip quiet");

export function NoticeStateChip({ state, waitingDays, confirmedAt, documentNo, deadline, testId = "notice-state" }: {
  state: NoticeState;
  waitingDays: number | null;
  confirmedAt: string | null;
  documentNo: string | null;
  deadline?: string | null;
  testId?: string;
}) {
  return (
    <span
      className={cls(state)}
      data-testid={testId}
      data-state={state}
      title={
        state === "waiting" && deadline
          ? `${t(PAYMENT_NOTICE_MSG.confirmDeadline)} ${mdSlash(deadline)}`
          : (state === "unissued" || state === "draft") && documentNo
            ? unissuedTitle(documentNo) // 番号のある下書き（#276）
            : undefined
      }
    >
      {noticeStateText(state, { waitingDays, confirmedAt, documentNo })}
    </span>
  );
}

/** 仕入の一覧の上の切り替え：仕入（/purchases）｜{paymentNotice}（/payment-notices）。左のメニューは「仕入」1つのまま */
export function PurchaseKindSwitch({ value }: { value: "purchases" | "notices" }) {
  const nav = useNavigate();
  return (
    <Segmented
      options={[
        { value: "purchases" as const, label: PURCHASE_MSG.list, testId: "kind-purchases" },
        { value: "notices" as const, label: t(PAYMENT_NOTICE_MSG.listTab), testId: "kind-notices" },
      ]}
      value={value}
      onChange={(v) => nav(v === "notices" ? "/payment-notices" : "/purchases")}
      label={PURCHASE_MSG.list}
      testId="purchase-kind"
    />
  );
}
